// Selectors
export const spinnerValue = (state): String => state.commonState.spinner;
export const snackbarValue = (state): String => state.commonState.snackbar;
export const profileActiveTab = (state): String => state.commonState.profileActiveTab;

